export default "__VITE_ASSET__Dl0xDtyf__"